/** Canonical Topic slug contract shared by the sys API and notification destinations. */
export const TOPIC_SLUG_MIN_LENGTH = 3;
export const TOPIC_SLUG_MAX_LENGTH = 80;
export const TOPIC_SLUG_PATTERN = /^[a-z0-9][a-z0-9-]*$/i;

export function isValidTopicSlug(value: unknown): value is string {
	return typeof value === 'string'
		&& value.length >= TOPIC_SLUG_MIN_LENGTH
		&& value.length <= TOPIC_SLUG_MAX_LENGTH
		&& TOPIC_SLUG_PATTERN.test(value);
}
